import { $http } from "@/plugins/axios";

const state = {
  form: {
    id: null,
    name: "",
    phone: "",
    email: "",
    website: "",
    address: "", 
    about: "",
    lat: 0,
    lng: 0,
    cover: null,
    logo: null,
  },
};

const mutations = {
  SET_COMPANY_INFO(state, payload) {
    state.form = payload;
  },
};

const actions = {
  async get({ commit }) {
    const { payload } = await $http.get(`company-admin/company-info`);
    commit("SET_COMPANY_INFO", payload);
  },
  async update({ state, dispatch }) {
    const formData = new FormData();
    formData.append("name", state.form.name);
    formData.append("phone", state.form.phone);
    formData.append("email", state.form.email);
    formData.append("website", state.form.website);
    formData.append("address", state.form.address);
    formData.append("about", state.form.about);
    if (state.form.cover) {
      formData.append("cover", state.form.cover);
    }
    if (state.form.logo) {
      formData.append("logo", state.form.logo);
    }
    formData.append("lat", state.form.lat || 0);
    formData.append("lng", state.form.lng || 0);

    await $http.post(`company-admin/company-info`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    await dispatch("get"); // Fetch updated data after successful update
  },
  show({ commit }, item) {
    commit("SET_COMPANY_INFO", item);
  },
  async fetchBanks() {
    const { payload } = await $http.get("company-admin/banks");
    return payload;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
